@use "/src/styles/functions";
@use "/src/styles/global-variables";

.imgContainer {
  width: 100%;
  transition: all 0.3s ease-in-out;
  overflow: scroll;
  text-align: center;
  max-height: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  &__image {
    width: 100%;
    height: auto;
    margin: 0 auto;
    transition: all 0.3s ease-in-out;
  }
}
.container {
  flex-grow: 1;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.dragCursor {
  cursor: move;
}

.imgViewer {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 60dvh;
  gap: functions.space(20);

  &__button {
    padding-top: functions.space(20);
    justify-content: center;
    align-items: center;
    display: flex;
    gap: functions.space(8);
  }

  &__header {
    display: flex;
    justify-content: space-between;
  }
}
